(function ($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfFieldBsbPrivate', ['BankModel', 'thfFieldHelper', '$sce', function (BankModel, thfFieldHelper, $sce) {
        var link = function (scope, el) {
            scope.isValid = thfFieldHelper.isValid;
            scope.labelIdentifier = thfFieldHelper.formLabelIdentifier();
            scope.tooltip = $sce.trustAsHtml((typeof scope.field.tooltip !== 'undefined') ? scope.field.tooltip : '');
            scope.fieldType = 'password';
            scope.toggleType = function(event) {
                event.preventDefault();
                event.stopPropagation();

                scope.fieldType = scope.fieldType == 'password' ? 'text' : 'password';
            }

            scope.loading = false;
            scope.valid = {
                show: false,
                icon: scope.formState.icon.tick
            };

            scope.validation[scope.field.name] = {result: true, message: ''};

            scope.lastKeyPressed = 0;
            scope.preventLengthyPaste = function(event) {
                if(typeof scope.field.maxLength === 'undefined') {
                    return true;
                }
                
                scope.lastKeyPressed = event.keyCode;

                var value = event.target.value;
                if(scope.lastKeyPressed != 8 && scope.lastKeyPressed != 46) {
                    scope.model[scope.field.name] = value.substring(0, scope.field.maxLength);
                }
            }
            
            function bsbCheck() {
                scope.valid.show = false;
                if( typeof scope.model[scope.field.name] !== 'undefined' && scope.model[scope.field.name] != '' ) {
                    scope.loading = true;

                    BankModel.bsbCheck(scope.model[scope.field.name]).then(
                        function (response) {
                            if( response.result ) {
                                scope.valid.icon = scope.formState.icon.tick;
                                scope.formState.validation[scope.field.name] = true;
                                scope.validation[scope.field.name].result = true;
                                scope.validation[scope.field.name].message = '';
                            }
                            else {
                                scope.valid.icon = scope.formState.icon.invalid;
                                scope.formState.validation[scope.field.name] = false;
                                scope.validation[scope.field.name].result = false;
                                scope.validation[scope.field.name].message = 'Must be a valid BSB Number';
                            }
                            scope.valid.show = true;
                            scope.loading = false;
                        },
                        function () {
                            scope.formState.validation[scope.field.name] = false;
                            scope.valid.show = true;
                            scope.valid.icon = scope.formState.icon.invalid;
                            scope.loading = false;
                            scope.validation[scope.field.name].result = false;
                            scope.validation[scope.field.name].message = 'Must be a valid BSB Number';
                        });
                }
            }

            scope.$watch('model.'+scope.field.name, bsbCheck, true);
            scope.$watch('model.'+scope.field.name, function(newValue, oldValue) {
                if(oldValue !== newValue) {
                    scope.model[scope.field.name] = thfFieldHelper.escapeValue(scope.model[scope.field.name]);
                }
            }, true);
        };
        return {
            'restrict': 'E',
            'replace': true,
            'scope': {
                'formState': '=',
                'formField': '=',
                'formModel': '=',
                'field': '=',
                'validation': '=',
                'model': '=',
                'fieldActions': '=',
                'validationRules': '='
            },
            'link': link,
            'templateUrl': function() {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/fields/bsb-private.html');
            }
        };
    }]);
})(jQuery, angular, window);
